import axios from 'axios';
import router from './../../router.js';

// Create an axios instance
const service = axios.create({
    baseURL: '/',

    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With':  'XMLHttpRequest',
    },
});

service.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        if (error.response.status === 401) {
            router.push('/admin');
        }
        // if (error.response.status === 401) {
        //     router.push('/login');
        // }
        // if (error.response.status === 403) {
        //     window.location.href = '/403';
        // }
        return Promise.reject(error);
    },
);

export default service;
